import LiveEventsManager from "../modules/live-events-manager";
import $ from "jquery";

const LiveViewer = {};

LiveViewer.init = () => {

    /**
     * Move banners robaA, robaB and robaC to mobile
     */
    $(window).on(
        'cs:leftLiveEventBannerLoad', function (event) {
            event.preventDefault();
            var typology = $('[data-live-event-banner-typology]').data('live-event-banner-typology');
            if (typology !== "sports") {
                var container = $('#live-events-container'),
                    numberOfComments = $('.row', container).length,
                    bannerClone = $('[data-banner="left"] > div').clone(),
                    bannerSecondClone = $('[data-banner="left-second"] > div').clone(),
                    bannerThirdClone = $('[data-banner="left-third"] > div').clone();

                $('script', bannerClone).remove();

                if ($('.banner-f1-mobile').length === 0) {
                    if (numberOfComments > 0) {
                        bannerClone.wrap('<div class="banner-f1-mobile"></div>').parent().insertAfter($('.row:first', container));
                        if (numberOfComments < 5) {
                            bannerSecondClone.wrap('<div class="banner-f1-mobile second"></div>').parent().insertAfter($('.row:last', container));
                            bannerThirdClone.wrap('<div class="banner-f1-mobile third"></div>').parent().insertAfter($('.row:last', container));
                        } else {
                            bannerSecondClone.wrap('<div class="banner-f1-mobile second"></div>').parent().insertAfter($('.row:eq(4)', container));
                            if (numberOfComments < 10) {
                                bannerThirdClone.wrap('<div class="banner-f1-mobile third"></div>').parent().insertAfter($('.row:last', container));
                            } else {
                                bannerThirdClone.wrap('<div class="banner-f1-mobile third"></div>').parent().insertAfter($('.row:eq(9)', container));
                            }
                        }
                    } else {
                        bannerClone.wrap('<div class="banner-f1-mobile"></div>').parent().appendTo(container);
                        bannerSecondClone.wrap('<div class="banner-f1-mobile second"></div>').parent().appendTo(container);
                        bannerThirdClone.wrap('<div class="banner-f1-mobile third"></div>').parent().appendTo(container);
                    }
                } else {
                    $('div.banner-f1-mobile').html(bannerClone);
                    $('div.banner-f1-mobile.second').html(bannerSecondClone);
                    $('div.banner-f1-mobile.third').html(bannerThirdClone);
                }
            }
        }
    );

    $(window).on(
        'cs:leftLiveEventBannerUpdatePosition', function (event) {
            event.preventDefault();

            var typology = $('[data-live-event-banner-typology]').data('live-event-banner-typology');

            if (typology !== "sports") {
                var container = $('#live-events-container'),
                    numberOfComments = $('.row', container).length,
                    bannerMobile = $('.banner-f1-mobile'),
                    bannerSecondMobile = $('.banner-f1-mobile.second'),
                    bannerThirdMobile = $('.banner-f1-mobile.third');

                if (bannerMobile.length > 0) {
                    bannerMobile.insertAfter($('.row:first', container));
                }
                if (bannerSecondMobile.length > 0) {
                    if (numberOfComments < 5) {
                        bannerSecondMobile.insertAfter($('.row:last', container));
                        bannerThirdMobile.insertAfter($('.row:last', container));
                    } else {
                        bannerSecondMobile.insertAfter($('.row:eq(4)', container));
                        if (numberOfComments < 10) {
                            bannerThirdMobile.insertAfter($('.row:last', container));
                        } else {
                            bannerThirdMobile.insertAfter($('.row:eq(9)', container));
                        }
                    }
                }
            }

        }
    );

    document.addEventListener('cs:updateBannersPosition', function (event) {
        let _bannerInterval = event.detail.bannerInterval;
        event.preventDefault();

        let _postslist = $('[data-live-viewer-posts-list]');

        let _banners = [];
        let _bannerDivs = $(_postslist).find('[data-id="revive-banner"]');
        $(_bannerDivs).each(function () {
            _banners.push(this);
        });

        let _postsDivs = $(_postslist).find('[data-live-viewer-post]');
        let _totalPosts = $(_postsDivs).length;

        let _postCount = 0;
        let _bannerIndex = 0;

        let _html = "";
        for (let _position = 0; _position < _totalPosts; _position++) {
            _html += _postsDivs[_position].outerHTML;
            _postCount = _postCount + 1;
            if (_postCount == _bannerInterval) {
                if (typeof _bannerDivs[_bannerIndex] != "undefined") {
                    _html += _bannerDivs[_bannerIndex].outerHTML;
                }
                _bannerIndex = _bannerIndex + 1;
                _postCount = 0;
            }
        }
        $(_postslist).html(_html);

    });

    let liveEventsManager = new LiveEventsManager();
    liveEventsManager.init();

    function getWindowWidth() {
        return $(window).width()
    }

    function getWindowHeight() {
        return $(window).height()
    }

    function isMobileWindow() {
        windowWidth = getWindowWidth();
        return windowWidth <= 567
    }

    var windowWidth = getWindowWidth();
    var isMobile = isMobileWindow();


// Hide Header on scroll down
    var didScroll;
    var lastScrollTop = 0;
    var delta = 5;
    var navbarHeight = $('header .nav').outerHeight();

    $(window).scroll(
        function () {
            if (typeof isMobileWindow === 'undefined' || isMobileWindow()) {
                didScroll = true;
            }

        }
    ).resize(
        function () {
            if (typeof isMobileWindow === 'undefined' || !isMobileWindow()) {
                $('#floating-share-buttonset').hide();
            }
        }
    );

    setInterval(
        function () {
            if (didScroll) {
                hasScrolled();
                didScroll = false;
            }
        }, 250
    );

    function hasScrolled() {
        var st = $(this).scrollTop();

        // Make sure they scroll more than delta
        if (Math.abs(lastScrollTop - st) <= delta) {
            return;
        }

        // If they scrolled down and are past the navbar, add class .nav-up.
        // This is necessary so you never see what is "behind" the navbar.

        if (st > lastScrollTop && st > navbarHeight) {
            $('#floating-share-buttonset').slideDown()
        } else {
            // Scroll Up
            if (st + $(window).height() < $(document).height()) {
                $('#floating-share-buttonset').slideUp();
            }
        }

        lastScrollTop = st;
    }

    $(window).on('load', function () {
        var idComment = getQueryParamValue("idComment");

        if (idComment) {
            var targetElement = $('[data-ws-post="' + idComment + '"]');
            if (targetElement.length) {
                $('html, body').scrollTop(targetElement.offset().top - 48, 2000);
            }
        }

        function getQueryParamValue(param) {
            var query = window.location.search.substring(1);
            var vars = query.split("&");
            for (var i = 0; i < vars.length; i++) {
                var pair = vars[i].split("=");
                if (pair[0] === param) {
                    return pair[1];
                }
            }
            return null;
        }
    });
};

export default LiveViewer